import axios from "axios";

const productionApiUrl = 'https://loganreidparker.clanweb.hu/api';
const developmentApiUrl = 'http://localhost/loganreidparker-web/public/api';

const isDevelopment = window.location.hostname === 'localhost';
const baseURL = isDevelopment ? developmentApiUrl : productionApiUrl;

if(isDevelopment){
    console.log(`API is running in ${isDevelopment ? 'DEVELOPMENT' : 'PRODUCTION'} mode. Base URL: ${baseURL}`);
}

const apiClient = axios.create({
    baseURL: baseURL,
    withCredentials: true,
});

export default apiClient;